import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { RealtimeConnectionService } from '@app/core/realtime/realtime-connection.service';
import { SessionRenewalService } from '@app/core/session/session-renewal.service';
import { MainContentFocusService } from '@app/core/shell/main-content-focus.service';
import { AppUpdateService } from '@app/core/updates/app-update.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  private readonly appUpdateService = inject(AppUpdateService);
  private readonly sessionRenewalService = inject(SessionRenewalService);
  private readonly mainContentFocusService = inject(MainContentFocusService);
  private readonly realtimeConnectionService = inject(RealtimeConnectionService);

  constructor() {
    this.appUpdateService.init();
    this.sessionRenewalService.init();
    this.mainContentFocusService.init();
    this.realtimeConnectionService.init();
  }

  protected focusMainContent(event: Event): void {
    event.preventDefault();
    this.mainContentFocusService.focusMainContent();
  }
}
